// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"e4359cd4","710":"e4359cd4"}[chunkId] + ".chunk.css";
};